///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.workflow_tasks = abcsetup.workflow_tasks || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.workflow_tasks.workflow = null;





///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.workflow_tasks = {
    init: function() {
        abcsetup.setTitle('Workflow Tasks');

        // Workflow history modal shown
        $('#workflow-history').on('show.bs.modal', function (e) {
            $('#workflow_history_id').text("");
            $(this).find('.modal-body').html('<center>Loading history...</center>');

            axios.get('/api/workflow_task/history/' + $(e.relatedTarget).data('id')).then(response => {
                $(this).find('.modal-body').html(response.data);
                $(this).find('.datatable').show();
                $('#workflow_history_id').text(" - Workflow # " + $(e.relatedTarget).data('workflow'));
            });
        });

        // Pricing Quick Edit modal shown
        $('#edit-pricing').on('show.bs.modal', function (e) {
            $(this).find('.modal-body').html('<center>Loading Pricing Information...</center>');

            axios.get('/api/abc_item_pricing/edit?workflow_task=' + $(e.relatedTarget).data('workflow_task')).then(response => {
                $(this).find('.modal-feedback').html("");
                $(this).find('.modal-body').html(response.data);
                $(this).find('.datatable').show();
                abcsetup.abc_item_pricing.manage._init();
                abcsetup.abc_item_pricing.manage.calc_margins();
            });
        });
    },
}
